var exports = {
  "a": "Box__Q8ST7s",
};

module.exports = exports;
